"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var SearchAndFilter_1 = __importDefault(require("atomicComponents/organisms/SearchAndFilter"));
var InvoicesDropdown_1 = __importDefault(require("./InvoicesDropdown"));
var utils_1 = require("./utils");
var InvoiceSearchAndFilter = function (_a) {
    var invoices = _a.invoices, selectedFilters = _a.selectedFilters, setSelectedFilters = _a.setSelectedFilters, searchText = _a.searchText, setSearchText = _a.setSearchText;
    var opts = utils_1.filterGroupDefinitions.map(function (_a) {
        var makeOptions = _a.makeOptions;
        return makeOptions(invoices);
    }).flat();
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", justifyContent: "flex-end", width: 845, pb: 2 }, { children: [(0, jsx_runtime_1.jsx)(SearchAndFilter_1.default, { searchProperties: { searchText: searchText, setSearchText: setSearchText }, filterProperties: { options: opts, results: selectedFilters, setResults: setSelectedFilters } }), (0, jsx_runtime_1.jsx)(InvoicesDropdown_1.default, { items: invoices })] })));
};
exports.default = react_1.default.memo(InvoiceSearchAndFilter);
